import { useEffect } from 'react';
import { Box, Flex, PrimaryPaper } from '@atoms/layout';
import { useRefreshSyncStore } from '@libs/store/refreshSync';
import { ShiftTemplatesFilters } from './filters';
import { TemplatesTableMenu } from './menu';
import { ShiftTemplatesTable } from './table/table';
import {
  useShiftTemplateDrawerStore,
  useShiftTemplatesFiltersStore,
  useShiftTemplatesList,
} from '@libs/store/shiftTemplates';
import { EditShiftTemplateDrawer } from './drawers/editShiftTemplateDrawer';
import { TemplateListItem } from '@libs/models/shiftTemplates';
import { useLocationStore } from '@libs/store/locations';

export function ShiftsTemplatesListPage() {
  const { refreshTrigger, callRefresh } = useRefreshSyncStore();
  const { currentLocationID, loadSimple } = useLocationStore();
  const { initialized: listInitialized, load, list } = useShiftTemplatesList();
  const { activeFilters } = useShiftTemplatesFiltersStore();
  const { openDrawer } = useShiftTemplateDrawerStore();

  const loading = !listInitialized;

  const localizationSubset = 'templates.shiftTemplates.listPage';

  useEffect(() => {
    callRefresh();
  }, [callRefresh]);

  useEffect(() => {
    if (!currentLocationID) {
      loadSimple();
    }
  }, [currentLocationID]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    if (currentLocationID) {
      load({ ...activeFilters, location: { key: 'location', value: [currentLocationID] } });
    }
  }, [load, refreshTrigger, activeFilters, currentLocationID]);

  const handleRowClick = (row: TemplateListItem) => {
    openDrawer(row.id, row, 'edit');
  };

  return (
    <>
      <TemplatesTableMenu loading={loading} localizationSubset={localizationSubset} />
      <PrimaryPaper sx={{ height: '100%', minHeight: 0, mt: 2 }}>
        <Flex column height="100%">
          <ShiftTemplatesFilters loading={loading} localizationSubset={localizationSubset} />
          <Box mt={2} height="100%" minHeight={0}>
            <ShiftTemplatesTable
              loading={loading}
              rows={list}
              localizationSubset={localizationSubset}
              onRowClick={handleRowClick}
            />
          </Box>
        </Flex>
      </PrimaryPaper>
      <Drawers />
    </>
  );
}

function Drawers() {
  const { open: openEditShiftTemplateDrawer } = useShiftTemplateDrawerStore();
  const { callRefresh } = useRefreshSyncStore();

  return <>{openEditShiftTemplateDrawer && <EditShiftTemplateDrawer onSaveCall={callRefresh} />}</>;
}
